<div
  mat-dialog-title
  class="modal-title"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <span class="modal-title-label">📐 {{ t.PositionImageTitle }}</span>
  <button
    class="modal-close-button"
    mat-icon-button
    [matTooltip]="t.PositionImageCloseTooltip"
    (click)="onClose()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content style="padding: 16px;">
  <div style="text-align: center; margin-bottom: 12px;">
    <mat-icon style="font-size: 36px; width: 36px; height: 36px; color: #3f51b5;">zoom_in</mat-icon>
  </div>

  <h3 style="text-align: center; margin: 0 0 12px 0; color: #333; font-size: 18px;">{{ t.PositionImageHeading }}</h3>

  <!-- Touch device instructions -->
  <div *ngIf="isTouchDevice" style="margin-bottom: 12px;">
    <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
      <mat-icon style="color: #3f51b5; margin-right: 10px; font-size: 20px; width: 20px; height: 20px;">touch_app</mat-icon>
      <div style="font-size: 14px;">
        <strong>{{ t.PositionImageDragTitle }}</strong> Drag from the blue border area to move the image
      </div>
    </div>

    <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
      <mat-icon style="color: #3f51b5; margin-right: 10px; font-size: 20px; width: 20px; height: 20px;">pinch</mat-icon>
      <div style="font-size: 14px;">
        <strong>Pinch to Resize:</strong> Use two fingers to pinch and zoom the image
      </div>
    </div>

    <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
      <mat-icon style="color: #3f51b5; margin-right: 10px; font-size: 20px; width: 20px; height: 20px;">open_with</mat-icon>
      <div style="font-size: 14px;">
        <strong>{{ t.PositionImageResizeTitle }}</strong> Or drag the corner/edge handles
      </div>
    </div>

    <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
      <mat-icon style="color: #3f51b5; margin-right: 10px; font-size: 20px; width: 20px; height: 20px;">crop_rotate</mat-icon>
      <div style="font-size: 14px;">
        <strong>{{ t.PositionImageRotateTitle }}</strong> {{ t.PositionImageRotateDesc }}
      </div>
    </div>
  </div>

  <!-- Desktop instructions -->
  <div *ngIf="!isTouchDevice" style="margin-bottom: 12px;">
    <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
      <mat-icon style="color: #3f51b5; margin-right: 10px; font-size: 20px; width: 20px; height: 20px;">mouse</mat-icon>
      <div style="font-size: 14px;">
        <strong>{{ t.PositionImageDragTitle }}</strong> {{ t.PositionImageDragDesc }}
      </div>
    </div>

    <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
      <mat-icon style="color: #3f51b5; margin-right: 10px; font-size: 20px; width: 20px; height: 20px;">open_with</mat-icon>
      <div style="font-size: 14px;">
        <strong>{{ t.PositionImageResizeTitle }}</strong> {{ t.PositionImageResizeDesc }}
      </div>
    </div>

    <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
      <mat-icon style="color: #3f51b5; margin-right: 10px; font-size: 20px; width: 20px; height: 20px;">crop_rotate</mat-icon>
      <div style="font-size: 14px;">
        <strong>{{ t.PositionImageRotateTitle }}</strong> {{ t.PositionImageRotateDesc }}
      </div>
    </div>
  </div>

  <div style="background: #fff3e0; padding: 10px; border-radius: 6px; margin-bottom: 12px; border-left: 3px solid #ff9800;">
    <div style="display: flex; align-items: flex-start;">
      <mat-icon style="color: #ff9800; margin-right: 10px; flex-shrink: 0; font-size: 20px; width: 20px; height: 20px;">info</mat-icon>
      <div style="font-size: 13px;">
        <strong style="color: #e65100;">{{ t.PositionImageTipLabel }}</strong>
        <span style="color: #555;"> {{ t.PositionImageTipText }}</span>
      </div>
    </div>
  </div>

  <div style="text-align: center; color: #666; font-size: 13px;">
    {{ t.PositionImageReady }}
  </div>
</div>
<div mat-dialog-actions align="center" style="padding: 12px 16px;">
  <button
    mat-raised-button
    color="primary"
    (click)="onGotIt()"
    style="min-width: 120px;"
  >
    {{ t.PositionImageGotIt }}
  </button>
</div>

